function escapeHtml(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function amountCell(amount) {
  if (amount === null || amount === undefined) return '';
  const number = Number(amount);
  return Number.isFinite(number) ? number.toFixed(2) : '';
}

function buildTableRows(items, columns) {
  if (!Array.isArray(items) || items.length === 0) {
    return '<tr><td colspan="' + columns.length + '">Sin registros</td></tr>';
  }

  return items.map((item) => {
    const cells = columns.map((column) => {
      const rawValue = column.accessor(item);
      const value = column.type === 'amount' ? amountCell(rawValue) : escapeHtml(rawValue);
      return `<td>${value}</td>`;
    }).join('');
    return `<tr>${cells}</tr>`;
  }).join('');
}

function buildExcelDocument(data) {
  const incomeColumns = [
    { header: 'Fecha', accessor: (item) => item.incomeDate || '' },
    { header: 'Tipo', accessor: (item) => item.typeLabel || '' },
    { header: 'Estado', accessor: (item) => item.statusLabel || '' },
    { header: 'Monto', accessor: (item) => item.amount, type: 'amount' },
    { header: 'Moneda', accessor: (item) => item.currency || '' },
    { header: 'Método de pago', accessor: (item) => item.paymentMethodLabel || '' },
    { header: 'Referencia', accessor: (item) => item.referenceNumber || '' },
    { header: 'Creado por', accessor: (item) => item.createdBy || '' },
    { header: 'Aprobado por', accessor: (item) => item.approvedBy || '' },
    { header: 'Notas', accessor: (item) => item.notes || '' }
  ];

  const expenseColumns = [
    { header: 'Fecha', accessor: (item) => item.expenseDate || '' },
    { header: 'Motivo', accessor: (item) => item.reasonLabel || '' },
    { header: 'Monto', accessor: (item) => item.amount, type: 'amount' },
    { header: 'Moneda', accessor: (item) => item.currency || '' },
    { header: 'Método de pago', accessor: (item) => item.paymentMethodLabel || '' },
    { header: 'Proveedor', accessor: (item) => item.providerName || '' },
    { header: 'Creado por', accessor: (item) => item.createdBy || '' },
    { header: 'Notas', accessor: (item) => item.notes || '' },
    { header: 'Estatus incidente', accessor: (item) => item.incident?.statusLabel || '' },
    { header: 'Detalle incidente', accessor: (item) => item.incident?.description || '' }
  ];

  const incomesTable = buildTableRows(data.incomes, incomeColumns);
  const expensesTable = buildTableRows(data.expenses, expenseColumns);

  const incomeHeaders = incomeColumns.map((column) => `<th>${escapeHtml(column.header)}</th>`).join('');
  const expenseHeaders = expenseColumns.map((column) => `<th>${escapeHtml(column.header)}</th>`).join('');

  return `<!DOCTYPE html>
<html lang="es">
  <head>
    <meta charset="utf-8" />
    <title>Dashboard financiero</title>
    <style>
      body { font-family: Arial, sans-serif; }
      table { border-collapse: collapse; width: 100%; margin-bottom: 24px; }
      th, td { border: 1px solid #999; padding: 6px 8px; font-size: 12px; }
      th { background: #f2f2f2; text-transform: uppercase; font-weight: bold; }
      caption { text-align: left; font-weight: bold; margin-bottom: 8px; }
    </style>
  </head>
  <body>
    <h1>Dashboard financiero</h1>
    <p>Período: ${escapeHtml(data.rangeLabel || '')}</p>
    <table>
      <caption>Ingresos</caption>
      <thead>
        <tr>${incomeHeaders}</tr>
      </thead>
      <tbody>
        ${incomesTable}
      </tbody>
    </table>

    <table>
      <caption>Egresos</caption>
      <thead>
        <tr>${expenseHeaders}</tr>
      </thead>
      <tbody>
        ${expensesTable}
      </tbody>
    </table>
  </body>
</html>`;
}

async function handleExportClick(button) {
  const url = button.getAttribute('data-export-url');
  if (!url) return;

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Preparando...';

  try {
    const response = await fetch(url, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) {
      throw new Error(`Respuesta inesperada (${response.status})`);
    }
    const payload = await response.json();
    const html = buildExcelDocument(payload);
    const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
    const href = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = href;
    link.download = payload.fileName || 'dashboard_finanzas.xls';
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(href);
    link.remove();
  } catch (error) {
    console.error('No se pudo generar el Excel', error);
    window.alert('No se pudo generar el Excel. Inténtalo nuevamente.');
  } finally {
    button.disabled = false;
    button.textContent = originalText;
  }
}

export function initFinanceDashboardPage() {
  const exportButton = document.querySelector('[data-finance-export]');
  if (!exportButton) return;

  exportButton.addEventListener('click', () => {
    handleExportClick(exportButton);
  });
}
